<template>
  <HeaderComponent :moduleName="'Thalamus'" v-if="mostrarHeaderEMenu" :buildMode="envMode" />
  <body class="inicial">
    <main
      id="main"
      :class="['main-altura', { 'main-altura--scroll-janela': paginaComScrollJanela }]"
    >
      <!-- <menu-lateral v-if="mostrarHeaderEMenu" /> -->
      <section
        :class="{
          'section-altura': mostrarHeaderEMenu,
          'section-altura--scroll-janela': paginaComScrollJanela,
        }"
      >
        <router-view />
      </section>
    </main>
  </body>
</template>
<script>
import { HeaderComponent } from "roboflex-thalamus-componentes-vue3-lib";
// import MenuLateral from "./components/menuLateral.vue";
import { sso } from "roboflex-thalamus-sso-lib";

export default {
  components: {
    HeaderComponent,
    // MenuLateral,
  },
  data() {
    return {
      envMode: process.env.NODE_ENV || "production",
      /** Só true quando há usuário com id (evita erro na lib ao acessar .id em null após login). */
      usuarioPronto: false,
    };
  },
  computed: {
    mostrarHeaderEMenu() {
      return this.$route.name !== 'login' && this.usuarioPronto;
    },
    paginaComScrollJanela() {
      return this.$route.name === 'painelRoot' || this.$route.name === 'painelRootEmpresa';
    },
  },
  watch: {
    '$route'(to) {
      if (to.name !== 'login') this.checarUsuario();
    },
  },
  mounted() {
    this.checarUsuario();
  },
  methods: {
    checarUsuario() {
      if (this.$route.name === 'login') {
        this.usuarioPronto = false;
        return;
      }
      const id = sso.getUsuarioLogado()?.id;
      if (id) {
        this.usuarioPronto = true;
        return;
      }
      // Após login, o SSO pode ainda não ter escrito o usuário; tentar no próximo tick e uma vez após 100ms
      this.$nextTick(() => {
        setTimeout(() => {
          this.usuarioPronto = !!sso.getUsuarioLogado()?.id;
          if (!this.usuarioPronto) {
            setTimeout(() => { this.usuarioPronto = !!sso.getUsuarioLogado()?.id; }, 100);
          }
        }, 0);
      });
    },
  },
}
</script>
<style>
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css");

*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--cor-separador);
  border-radius: 20px;
}

.abas {
  display: flex;
  height: 2.5rem;
  margin-left: 1.5rem;
  align-items: end;

  a {
    padding: .5em 1em;
    border-radius: 12px 12px 0 0;
    border: 1px solid var(--cor-separador);
    border-bottom: none;
    align-content: center;
    cursor: pointer;
  }

  .ativo {
    background-color: var(--cor-primaria);
    color: var(--cor-bg);
    height: 2rem;
    transition: all 400ms ease-in-out;
  }
}

a {
  cursor: pointer;
}

.main-altura {
  height: calc(100vh - 64px);
  min-height: 0;
}

.main-altura--scroll-janela {
  height: auto;
  min-height: calc(100vh - 64px);
}

.section-altura {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.section-altura--scroll-janela {
  overflow: visible;
}
</style>
